import React, { useState, useEffect, useRef } from 'react';
import "./product-details.css";
import { Col } from 'react-bootstrap';
import { useLocation } from "react-router-dom";
import { GetProductsbById, addBasket, getBasketList, deleteBasket, getDiscountProduct, getFavoriteList, getAddToFavorite, deleteFavorite } from '../../utils/api';
import useToastNotification from '../../hooks/useToastNotification';
import Loader from '../../components/loader/dotloader';
import { Toast } from 'primereact/toast';
import Trash from '../../assets/icons/trash.svg';
import ThreeLoader from '../loader/threeDots';
import Overlay from 'react-bootstrap/Overlay';
import Tooltip from 'react-bootstrap/Tooltip';
import { Dialog } from 'primereact/dialog';
import Hearth from '../../assets/icons/hearth.svg';
import HeartBold from '../../assets/icons/heart-bold.svg';
import { useCart } from '../../contexts/CartContext';

const ProductDetail = () => {
  const location = useLocation();
  const [productDetail, setProductDetail] = useState(null);
  const [loading, setLoading] = useState(false);
  const toast = useRef(null);
  const { showError, showSuccess } = useToastNotification();
  const [inputValue, setInputValue] = useState("");
  const [selectedDiscount, setSelectedDiscount] = useState(null);
  const [showDiscount, setShowDiscount] = useState(false);
  const [show, setShow] = useState(false);
  const [loadingQuantities, setLoadingQuantities] = useState(false);
  const [isScrolling, setIsScrolling] = useState(false); // فلگ برای تشخیص اسکرول
  const [inputValues, setInputValues] = useState({});
  const { addToCart } = useCart();

  const typingTimers = useRef({});
  // داخل کامپوننت:
  const refs = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک
  const ref = useRef({}); // یک آبجکت برای ذخیره refs به صورت داینامیک
  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (ref.current && !ref.current.contains(event.target)) {
  //       setShow(false); // تابعی که overlay رو می‌بنده
  //     }
  //   };

  //   if (show) {
  //     document.addEventListener("mousedown", handleClickOutside);
  //   } else {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   }

  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [show]);
  const getRef = (id) => {
    if (!refs.current[id]) {
      refs.current[id] = React.createRef();
    }
    return refs.current[id];
  };
  const handleDialogClose = () => {
    setVisible(false);
  };
  const fetchDiscountProduct = async (id) => {
    try {
      setShow(false); // مخفی کردن اولیه
      setSelectedDiscount(null); // پاک کردن مقدار قبلی برای جلوگیری از کش شدن

      const res = await getDiscountProduct(id);
      if (res.data.length > 0) {
        setTimeout(() => {
          setSelectedDiscount({ id, discounts: res.data });
          setShow(true); // نمایش تخفیف جدید
        }, 100); // تاخیر کوتاه برای اطمینان از به‌روز شدن مقدار
      } else {
        setSelectedDiscount(null);
        setShow(false);
      }
    } catch (error) {
      console.error('Error fetching discount:', error);
    }
  };
  const fetchDataDetail = async () => {
    try {
      setLoading(true);
      const queryParams = new URLSearchParams(location.search);
      const id = queryParams.get("id");

      if (!id) return;

      const userInfo = JSON.parse(localStorage.getItem('userInfo'));
      const userId = userInfo?.si;

      const productRes = await GetProductsbById(id);
      const productData = productRes.data;

      if (userId) {
        const basketRes = await getBasketList(userId);
        const basketItem = basketRes.data.find(item => item.Id_Kala === productData.si);
        if (basketItem) {
          productData.count = basketItem.Nq;
          productData.basketId = basketItem.Si;
        } else {
          productData.count = 0;
        }

        const favoritRes = await getFavoriteList(userId);
        const favoritItem = favoritRes.data.find(item => item.Id_Kala === productData.si);
        if (favoritItem) {
          productData.isFavorit = true;
        } else {
          productData.isFavorit = false;
        }
      }
      console.log('..........', productData)
      setProductDetail(productData);
      await fetchDiscountProduct(productData.si);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (selectedDiscount && productDetail?.count) {
      console.log(productDetail?.count)
      checkDiscount(productDetail?.count);
    }
  }, [selectedDiscount, productDetail?.count]);
  useEffect(() => {
    fetchDataDetail();
  }, [location]);

  useEffect(() => {
    setInputValue(productDetail?.count ? productDetail.count.toString() : "");
  }, [productDetail]);
  const handleUpdateBasket = async (newCount) => {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));

    if (!JSON.parse(localStorage.getItem('userInfo')).si) {
      window.location.hash = 'login'; // هدایت به صفحه لاگین
      return;
    }
    try {
      setLoadingQuantities(true)
      console.log(productDetail)
      if (newCount >= productDetail.minorder) {
        const res = await addBasket({ id: productDetail.si, count: newCount, userId: JSON.parse(localStorage.getItem('userInfo')).si });
        if (res.status == 200) {
          // if (productDetail.count > newCount) {
          //   showSuccess(`${parseInt(productDetail.count) - parseInt(newCount)} کالا از سبد خرید حذف شد`)
          // } else {
          //   showSuccess(`${parseInt(newCount) - parseInt(productDetail.count)} کالا به سبد خرید اضافه شد`)
          // }
          setTimeout(() => {
            setLoadingQuantities(false)
            checkDiscount(newCount)
          }, 2000);
          setProductDetail(prev => ({ ...prev, count: newCount }));


        }

      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: product.BasketId
        });
        if (res.status == 200) {
          setLoadingQuantities(false)
          setProductDetail(prev => ({ ...prev, count: 0 }));
        }

      }
    } catch (error) {
      console.error('Error updating basket:', error);
    }
  };

  const checkDiscount = (count) => {
    if (selectedDiscount?.discounts.length > 0) {


      for (const item of selectedDiscount?.discounts) {
        const nq = item.Nq;
        if (nq) {
          if (nq.includes("از") && nq.includes("تا")) {
            // بازه بین دو عدد
            const match = nq.match(/از\s*(\d+)\s*تا\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              const to = parseInt(match[2]);

              console.log(from, to)
              if (count >= from && count <= to) {
                console.log(selectedDiscount, item.Price, count)
                setProductDetail(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          } else if (nq.includes("بیشتراز")) {
            const match = nq.match(/بیشتراز\s*(\d+)/);
            if (match) {
              const from = parseInt(match[1]);
              if (count > from) {
                setProductDetail(prev => ({ ...prev, discountPrice: item.Price }));
                break;
              }
            }
          }
        }

      }


    }
  }
  useEffect(() => {

  }, [productDetail])
  const handleInputChange = (value) => {
    const numericValue = value.replace(/\D/g, '');
    setInputValue(numericValue);

    if (typingTimers.current.timer) {
      clearTimeout(typingTimers.current.timer);
    }

    typingTimers.current.timer = setTimeout(() => {
      const parsed = parseInt(numericValue, 10);
      const finalCount = isNaN(parsed) || parsed < productDetail.minorder ? productDetail.minorder : parsed;
      setInputValue(finalCount.toString());
      handleUpdateBasket(finalCount);
    }, 1200);
  };
  const [visible, setVisible] = useState(false); // Dialog visibility state
  const [autoplay, setAutoplay] = useState(true); // کنترل وضعیت autoplay


  const openDialog = async (product) => {

    setSelectedDiscount(null)
    setVisible(true);

    await fetchDiscountProduct(product.si)
    setAutoplay(false);
  };
  const handleMouseDownslid = () => setIsScrolling(false);
  const handleMouseMoveslid = () => setIsScrolling(true);
  const handleMouseUpslid = (product) => {
    if (!isScrolling) {
      openDialog(product);
    }
  }



  const handleDialogIncrease = async () => {
    const newCount = productDetail.count + 1;


    try {
      setLoadingQuantities(true)
      let res = await addBasket({
        id: productDetail.si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        setInputValues((prevValues) => ({
          ...prevValues,
          [productDetail.Si]: newCount,
        }));
        setProductDetail(prev => ({ ...prev, count: newCount }));
        setTimeout(() => {
          setLoadingQuantities(false)
          showSuccess(`${parseInt(newCount)} عدد ${productDetail.kalaname} در سبد خرید شما وجود دارد.`)
        }, 1000);
      }

    } catch (error) {
      console.error('Error increasing product count in dialog:', error);
    }
  };
  const fetchFavorite = async () => {
    try {
      setLoading(true)
      const res = await getFavoriteList(JSON.parse(localStorage.getItem('userInfo')).si);
      const favoriteData = res.data.reduce((acc, item) => {
        acc[item.Id_Kala] = {
          isFavorit: true,      // تعداد محصول در سبد خرید
          favoriteId: item.Si // شناسه سبد خرید برای حذف یا ویرایش
        };
        return acc;
      }, {});
      setFavoritList(favoriteData);
      return favoriteData;
    } catch (error) {
      console.error('Error fetching basket:', error);
      return {};
    } finally {
      setLoading(false)
    }
  };
  const handleDialogDecrease = async () => {
    const newCount = productDetail.count - 1;

    // همگام‌سازی مقدار در دیالوگ و لیست محصولات
    setProductDetail(prev => ({ ...prev, count: newCount }));

    try {
      setLoadingQuantities(true)
      if (newCount >= productDetail.minorder) {
        let res = await addBasket({
          id: productDetail.si,
          count: newCount,
          userId: JSON.parse(localStorage.getItem('userInfo')).si
        });
        if (res.status == 200) {
          showSuccess(`${parseInt(newCount)} عدد ${productDetail.kalaname} در سبد خرید شما وجود دارد.`)
          setInputValues((prevValues) => ({
            ...prevValues,
            [productDetail.si]: newCount,
          }));

          setProductDetail(prev => ({ ...prev, count: newCount }));


          setTimeout(() => {
            setLoadingQuantities(false)
          }, 1000);
        }
      } else {
        let res = await deleteBasket({
          userId: JSON.parse(localStorage.getItem('userInfo')).si,
          id: productDetail.basketId
        });
        if (res.status == 200) {
          addToCart();
          showSuccess(`کالا از سبد خرید حذف شد.`)
          setProductDetail(prev => ({ ...prev, count: newCount }));

          setTimeout(() => {
            setLoadingQuantities(false)
          }, 1000);
        }

      }
    } catch (error) {
      console.error('Error decreasing product count in dialog:', error);
    }
  };

  function convertToPersianNumbers(input) {
    if (input) {

      const persianDigits = ['۰', '۱', '۲', '۳', '۴', '۵', '۶', '۷', '۸', '۹'];
      return input.replace(/\d/g, (digit) => persianDigits[digit]);
    }
  }
  const handleAddToBasket = async (product, event) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    setSelectedDiscount(null)
    await fetchDiscountProduct(product.si);
    const newCount = product.minorder;

    setProductDetail(prev => ({ ...prev, count: newCount }));
    try {
      let res = await addBasket({
        id: product.si,
        count: newCount,
        userId: JSON.parse(localStorage.getItem('userInfo')).si
      });
      if (res.status == 200) {
        showSuccess(`${product.kalaname} به سبد خرید اضافه شد.`)
        addToCart();
        setProductDetail(prev => ({ ...prev, count: newCount }));


      }


    } catch (error) {
      console.error('Error adding to basket:', error);
    }
  };
  const getTotalPrice = (price, product) => {
    let totalPrice = parseInt(product.count) * parseInt(price)
    return totalPrice.toLocaleString()
  }

  const changeFavoritDialog = async (product) => {
    if (!JSON.parse(localStorage.getItem('userInfo'))) {
      window.location.hash = 'login';
      return;
    }
    if (!product.isFavorit) {
      let pay = {
        userId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.si
      }
      await getAddToFavorite(pay)
      setProductDetail(prevContent => ({
        ...prevContent,
        isFavorit: true

      }));

    } else {
      let pay = {
        UserId: JSON.parse(localStorage.getItem('userInfo')).si,
        productId: product.si
      }
      await deleteFavorite(pay)
      setProductDetail(prevContent => ({
        ...prevContent,
        isFavorit: false

      }));

    }
  }
  return (
    <div>
      <Toast ref={toast} />
      <section className='container' style={{ marginBottom: '8em' }}>
        {loading ? (
          <Loader isLoading={loading} />
        ) : (
          productDetail && (
            <div className="flex flex-wrap my-5">
              <Col md={3} sm={12}>
                <div className='img-box'>
                  <img src={productDetail.pic_a} draggable={false} className='img-slider' alt={productDetail.kalaname} />
                </div>
              </Col>
              <Col md={9} sm={12}>
                <div className="text-end p-3 max-sm:!text-center">
                  <h4 className='my-4 font-bold'>{productDetail.kalaname}</h4>
                  <span className='text-base'>توضیحات محصول: {productDetail.tp}</span>
                  <div className='d-flex align-items-center gap-3 mt-3'>
                    <span className='text-[14px] item'>کد کالا: {productDetail.code}</span>
                    <span className='text-[14px] item'>گروه کالا: {productDetail.grpname}</span>
                  </div>
                  <div className='d-flex align-items-center gap-5 '>
                    <h5 className={`${(productDetail.discountPrice && productDetail.discountPrice != productDetail.price) ? 'discount-price' : ''} mt-4 font-bold number-font`}>{parseInt(productDetail.price).toLocaleString()} تومان</h5>
                    {(productDetail.discountPrice && productDetail.discountPrice != productDetail.price) && (

                      <h5 className='mt-4 font-bold number-font'>{parseInt(productDetail.discountPrice).toLocaleString()} تومان</h5>
                    )}
                  </div>
                  <span className='text-[14px] item mt-5'>حداقل تعداد خرید: {productDetail.minorder} عدد</span>
                  <button className='mt-4 btn btn-primary w-25' onMouseDown={handleMouseDownslid}
                    onMouseMove={handleMouseMoveslid}
                    onMouseUp={() => handleMouseUpslid(productDetail)}>افزودن</button>
                  <div className='mt-3 body-item text-[#494C50] text-base fw-500 font-medium ' dangerouslySetInnerHTML={{ __html: productDetail.tpfull }} />


                  {/* {productDetail.count > 0 ? (
                    <div className='d-flex justify-content-start mt-4 gap-2 increas w-fit' ref={getRef(productDetail.si)}>
                      <button className='btn btn-primary' onClick={() => handleUpdateBasket(productDetail.count + 1)} style={{ width: '48px', height: '48px' }}>+</button>
                      {loadingQuantities ? (
                        <div className='form-control w-[48px] h-[48px] text-center d-flex align-items-center justify-content-center' style={{ width: '48px', height: '48px' }}>
                          <ThreeLoader />

                        </div>
                      ) : (
                        <input
                          className={`form-control w-[48px] h-[48px] text-center number-font ${loadingQuantities ? 'loading-dots' : ''}`}
                          style={{ height: '48px' }}
                          value={inputValue}
                          onChange={(e) => handleInputChange(e.target.value)}
                          onMouseEnter={async () => {
                            setSelectedDiscount(null)
                            await fetchDiscountProduct(productDetail.si)
                          }}
                        />
                      )}

                      <button className='btn btn-primary' onClick={() => handleUpdateBasket(productDetail.count - 1)} style={{ width: '48px', height: '48px' }}>
                        {productDetail.count === productDetail.minorder ? <img src={Trash} /> : '-'}
                      </button>
                    </div>
                  ) : (
                    <button className='mt-4 btn btn-primary w-25' onClick={() => handleUpdateBasket(productDetail.minorder)}>افزودن</button>
                  )} */}
                </div>

                {/* {selectedDiscount?.id === productDetail.si && selectedDiscount?.discounts.length > 0 && (
                  <div ref={ref}>
                    <Overlay
                      target={getRef(productDetail.si).current}
                      show={show && selectedDiscount?.id === productDetail.si}
                      placement="bottom"
                    >
                      {(props) => (
                        <Tooltip id="overlay-example" {...props}>
                          <div className="discount-list">
                            {selectedDiscount.discounts.map((discount, index) => (
                              <div key={index} className="discount-item">
                                <span className="number-font">{discount.Nq ?? ''}</span>
                                <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                              </div>
                            ))}
                          </div>
                        </Tooltip>
                      )}
                    </Overlay>
                  </div>

                )} */}
              </Col>
            </div>
          )
        )}
      </section>

      <Dialog
        draggable={false}
        dismissableMask
        visible={visible}
        style={{ width: '35vw' }}
        breakpoints={{ '1800px': '25vw', '1600px': '35vw','1300px': '50vw', '1100px': '50vw', '900px': '60vw', '600px': '400vw', '500px': '95vw' }}
        onHide={handleDialogClose}
        className="custom-dialog "
      >
        <div className='product-item'>
          <div className='d-flex justify-content-start gap-4 mobile-direction'>
            <div className='product-img mx-0 aspect-[4/4]'>
              <img src={productDetail?.pic_a} className='img-box img-product' alt={productDetail?.kalaname} />
              <img src={productDetail?.isFavorit ? HeartBold : Hearth} className='favorite-icon' alt="" onClick={(e) => { e.stopPropagation(); changeFavoritDialog(productDetail) }} />
            </div>
            <div>
              <div className='detail text-center d-flex align-items-center gap-3 justify-content-between'>
                <div className='flex-1 text-right text-mobile-center'>
                  <h4 className='mt-4'>{convertToPersianNumbers(productDetail?.kalaname)}</h4>
                  <span className='text-sm'>توضیحات محصول: {productDetail?.tp}</span>
                  <div className='d-flex align-items-center justify-content-start text-mobile-center gap-3 mt-2'>
                    <span className='text-[12px] item' >کد کالا: {convertToPersianNumbers(productDetail?.code)}</span>
                    <span className='text-[12px] item' >گروه کالا: {productDetail?.grpname}</span>
                  </div>
                  <div className='d-flex align-items-center gap-5 justify-content-start text-mobile-center'>
                    <h5 className={`${(productDetail?.discountPrice && productDetail?.discountPrice != productDetail?.price) ? 'discount-price' : ''} mt-2 number-font`}>{parseInt(productDetail?.price).toLocaleString()} تومان</h5>
                    {(productDetail?.discountPrice && productDetail?.discountPrice != productDetail?.price) && (

                      <h5 className='mt-2 number-font'>{parseInt(productDetail?.discountPrice).toLocaleString()} تومان</h5>
                    )}
                  </div>

                  <span className='text-[12px] item'>حداقل تعداد خرید محصول {convertToPersianNumbers((productDetail?.minorder)?.toString())} عدد</span>
                </div>



              </div>
            </div>
          </div>
          {selectedDiscount?.id === productDetail?.si && selectedDiscount?.discounts.length > 0 && (
            <div className="discount-list  flex-1 mt-4">
              {/* <h4 className='mt-4 text-lg text-right'>تخفیفات</h4> */}

              {selectedDiscount.discounts.map((discount, index) => (
                <div key={index} className="discount-item p-2">
                  <span className="number-font">{discount.Nq ?? ''}</span>
                  <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                </div>
              ))}
            </div>
          )}

          {productDetail?.count >= productDetail?.minorder ? (
            <div>
              <div className='text-center w-100 d-flex justify-content-end'>
                <div className='d-flex align-items-center justify-content-center mt-4 gap-2 increas w-fit' ref={getRef(productDetail.si)}>
                  <button className='btn btn-primary w-[48px]' onClick={handleDialogIncrease}>+</button>
                  {loadingQuantities ? (
                    <div className='form-control w-[48px] h-[48px] text-center three-loader d-flex align-items-center justify-content-center' style={{ width: '48px', height: '48px' }}>
                      <ThreeLoader />

                    </div>
                  ) : (
                    <input
                      className={`form-control w-[48px] h-[48px] text-center number-font ${loadingQuantities ? 'loading-dots' : ''}`}
                      style={{ height: '48px' }}
                      value={inputValue}
                      onChange={(e) => handleInputChange(e.target.value)}
                    // onMouseEnter={async () => {
                    //   setSelectedDiscount(null)
                    //   await fetchDiscountProduct(productDetail.si)
                    // }}
                    />
                  )}



                  <button className='btn btn-primary w-[48px] d-flex align-items-center justify-center' onClick={handleDialogDecrease}>
                    {productDetail.count === productDetail.minorder ? <img src={Trash} /> : '-'}
                  </button>
                </div>
              </div>

              {/* {selectedDiscount?.id === dialogContent.Si && selectedDiscount?.discounts.length > 0 && (
                <div ref={ref}>
                  <Overlay
                    target={getRef(dialogContent.Si).current}
                    show={show && selectedDiscount?.id === dialogContent.Si}
                    placement="left"
                  >
                    {(props) => (
                      <Tooltip id="overlay-example" {...props}>
                        <div className="discount-list">
                          {selectedDiscount.discounts.map((discount, index) => (
                            <div key={index} className="discount-item">
                              <span className="number-font">{discount.Nq ?? ''}</span>
                              <span className="number-font">{discount.Price?.toLocaleString() ?? ''} تومان</span>
                            </div>
                          ))}
                        </div>
                      </Tooltip>
                    )}
                  </Overlay>
                </div>

              )} */}
              <hr />
              <div className='d-flex align-items-center justify-content-between'>
                <div>
                  <h6 className='text-sm number-font d-flex' style={{ flexWrap: 'wrap' }}>مجموع ({inputValues[productDetail.si] ? inputValues[productDetail.si] : productDetail.count} کالا) : <span className='text-[#00a14b] font-bold number-font'>{getTotalPrice(productDetail.price, productDetail)} تومان</span></h6>
                </div>
                <button className='btn btn-outline-primary py-1 h-[40px]' style={{ fontSize: '12px', height: '40px', textWrap: 'nowrap' }} onClick={() => { window.location.href = '/orders' }}>مشاهده سبد خرید</button>
              </div>
            </div>

          ) : (
            <button className='mt-3 btn btn-primary w-100' onClick={(e) => handleAddToBasket(productDetail, e)}>افزودن</button>
          )}
        </div>
      </Dialog>
    </div>
  );
};

export default ProductDetail;
